/* eslint-disable max-len */
import { getProxiedServiceUrl } from '@xengage/gw-portals-url-js';
import { JsonRPCService } from '@xengage/gw-portals-transport-js';
// eslint-disable-next-line import/no-unresolved
import appConfig from 'app-config';

const {
    MLAccountPaymentMethods,
    MLRatingPaymentMethods
} = appConfig;

export default {
    addPaymentInstrument(sessionID, quoteID, codeOfPaymentMethod, preferredPaymentMethodInd, redirectURL, accountNumber, gpaMode, isSplUser = false, additionalHeaders = {}) {
        let promise = null;
        const paymentInstrumentRequestDTOML = {
            sessionUUID: sessionID,
            quoteID,
            paymentMethod: codeOfPaymentMethod,
            redirectURL,
            preferredPaymentMethodInd
        };
        if (gpaMode) {
            if (isSplUser) {
                promise = JsonRPCService.send(getProxiedServiceUrl('gatewayPayment'), 'getSecurePayLineUrl', [accountNumber, codeOfPaymentMethod, 'sso-add-pm', null], additionalHeaders);
            } else {
                promise = JsonRPCService.send(getProxiedServiceUrl('gatewayPayment'), 'getNewPaymentInstrumentUrlForSubmission', [paymentInstrumentRequestDTOML], additionalHeaders);
            }
        } else {
            promise = JsonRPCService.send(getProxiedServiceUrl('policyCommonPayment'), 'getNewPaymentInstrumentUrl', [paymentInstrumentRequestDTOML], additionalHeaders);
        }
        return promise;
    },
    getPaymentInstruments(sessionID, quoteID, accountNumber, gpaMode, additionalHeaders = {}) {
        let promise = null;
        if (gpaMode) {
            promise = JsonRPCService.send(getProxiedServiceUrl('gatewayPayment'), 'getPaymentInstrumentsForAccount', [accountNumber], additionalHeaders);
        } else {
            const paymentInstrumentRequestDTOML = {
                sessionUUID: sessionID,
                quoteID
            };
            promise = JsonRPCService.send(getProxiedServiceUrl('policyCommonPayment'), 'getPaymentInstruments', [paymentInstrumentRequestDTOML], additionalHeaders);
        }
        return promise;
    },
    getPaymentInstrumentsByPolicyNumber(policyNumber, additionalHeaders = {}) {
        const paymentInstrumentRequestDTOML = {
            sessionUUID: 1,
            policyNumber
        };
        return JsonRPCService.send(getProxiedServiceUrl('policyCommonPayment'), 'getPaymentInstrumentsByPolicyNumber', [paymentInstrumentRequestDTOML], additionalHeaders);
    },
    editPaymentInstrument(sessionUUID, quoteID, paymentInstrumentId, redirectURL, accountNumber, gpaMode, additionalHeaders = {}) {
        let promise = null;
        const paymentInstrumentRequestDTOML = {
            sessionUUID: sessionUUID,
            quoteID: quoteID,
            paymentMethod: MLAccountPaymentMethods.CREDIT_CARD,
            paymentInstrumentId: paymentInstrumentId,
            isEdit: true,
            redirectURL: redirectURL
        };
        if (gpaMode) {
            promise = JsonRPCService.send(getProxiedServiceUrl('gatewayPayment'), 'getEditPaymentInstrumentUrl', [paymentInstrumentRequestDTOML], additionalHeaders);
        } else {
            promise = JsonRPCService.send(getProxiedServiceUrl('policyCommonPayment'), 'getEditPaymentInstrumentUrl', [paymentInstrumentRequestDTOML], additionalHeaders);
        }
        return promise;
    },
    deletePaymentInstrument(sessionUUID, quoteID, paymentInstrumentId, accountNumber, gpaMode, additionalHeaders = {}) {
        let promise = null;
        if (gpaMode) {
            promise = JsonRPCService.send(getProxiedServiceUrl('gatewayPayment'), 'deletePaymentInstrument', [accountNumber, paymentInstrumentId], additionalHeaders);
        } else {
            const paymentInstrumentRequestDTOML = {
                sessionUUID,
                quoteID,
                paymentInstrumentId
            };
            promise = JsonRPCService.send(getProxiedServiceUrl('policyCommonPayment'), 'deleteSubmissionPaymentInstrument', [paymentInstrumentRequestDTOML], additionalHeaders);
        }
        return promise;
    },
    markOneTimePaymentCardForDeletion(accountNumber, paymentInstrumentId, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('gatewayPayment'), 'markOneTimePaymentCardForDeletion', [accountNumber, paymentInstrumentId], additionalHeaders);
    },
    markDownPaymentCardForDeletion(accountNumber, paymentInstrumentId, quoteId, gpaMode, sessionid, additionalHeaders = {}) {
        let promise = null;
        if (gpaMode) {
            promise = JsonRPCService.send(getProxiedServiceUrl('gatewayPayment'), 'markDownPaymentCardForDeletion', [accountNumber, paymentInstrumentId, quoteId], additionalHeaders);
        } else {
            promise = JsonRPCService.send(getProxiedServiceUrl('policyCommonPayment'), 'markDownPaymentCardForDeletion', [accountNumber, paymentInstrumentId, quoteId, sessionid], additionalHeaders);
        }
        return promise;
    },
    addBankAccountPaymentInstrumentBySubmission(paymentDetailsDTO, gpaMode, additionalHeaders = {}) {
        let promise = null;
        if (gpaMode) {
            promise = JsonRPCService.send(getProxiedServiceUrl('gatewayPayment'), 'addBankAccountPaymentInstrumentBySubmission', [paymentDetailsDTO], additionalHeaders);
        } else {
            promise = JsonRPCService.send(getProxiedServiceUrl('policyCommonPayment'), 'addBankAccountPaymentInstrumentBySubmission', [paymentDetailsDTO], additionalHeaders);
        }
        return promise;
    },
    addBankAccountPaymentInstrumentByEndorsement: (paymentDetails, policyNumber, jobId, additionalHeaders = {}) => {
        return JsonRPCService.send(getProxiedServiceUrl('gatewayPayment'), 'addBankAccountPaymentInstrumentByEndorsement', [paymentDetails, policyNumber, jobId], additionalHeaders);
    },
    getBankAccountDetails(token, accountNumber, gpaMode, additionalHeaders = {}) {
        let promise = null;
        if (gpaMode) {
            promise = JsonRPCService.send(getProxiedServiceUrl('gatewayBilling'), 'getBankAccountDetails', [token, accountNumber], additionalHeaders);
        } else {
            promise = JsonRPCService.send(getProxiedServiceUrl('billingData'), 'getBankAccountDetails', [token], additionalHeaders);
        }
        return promise;
    },
    getBankAccountDetailsWithSession(sessionToken, quoteID, paymentInstrumentID, additionalHeaders = {}) {
        const bankAccountRequestDTOML = {
            sessionUUID: sessionToken,
            quoteID: quoteID,
            paymentInstrumentID: paymentInstrumentID
        };
        return JsonRPCService.send(getProxiedServiceUrl('policyCommonPayment'), 'getBankAccountPaymentInstrument', [bankAccountRequestDTOML], additionalHeaders);
    },
    updateBankAccountDetails(bankAccountDetails, accountNumber, gpaMode, additionalHeaders = {}) {
        let promise = null;
        if (gpaMode) {
            promise = JsonRPCService.send(getProxiedServiceUrl('gatewayBilling'), 'updateBankAccountDetails', [bankAccountDetails, accountNumber], additionalHeaders);
        } else {
            promise = JsonRPCService.send(getProxiedServiceUrl('billingData'), 'updateBankAccountDetails', [bankAccountDetails], additionalHeaders);
        }
        return promise;
    },
    updateBankAccountDetailsWithSession(paymentDetails, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('policyCommonPayment'), 'updateBankAccountPaymentInstrument', [paymentDetails], additionalHeaders);
    },
    updateCreditCardDetails(accountNumber, token, creditCardExpDate, last4Digits, nickname, gpaMode = false, additionalHeaders = {}) {
        let promise = null;
        if (gpaMode) {
            promise = JsonRPCService.send(getProxiedServiceUrl('gatewayBilling'), 'updateCreditCardDetails', [accountNumber, token, creditCardExpDate, last4Digits, nickname], additionalHeaders);
        } else {
            promise = JsonRPCService.send(getProxiedServiceUrl('billingData'), 'updateCreditCardDetails', [accountNumber, token, creditCardExpDate, last4Digits, nickname], additionalHeaders);
        }
        return promise;
    },
    updateExistingCreditCardDetails(accountNumber, token, creditCardExpDate, last4Digits, nickname, gpaMode = false, additionalHeaders = {}) {
        let promise = null;
        if (gpaMode) {
            promise = JsonRPCService.send(getProxiedServiceUrl('gatewayBilling'), 'updateExistingCreditCardDetails', [accountNumber, token, creditCardExpDate, last4Digits, nickname], additionalHeaders);
        } else {
            promise = JsonRPCService.send(getProxiedServiceUrl('billingData'), 'updateExistingCreditCardDetails', [token, creditCardExpDate, last4Digits, nickname], additionalHeaders);
        }
        return promise;
    },
    deleteBankAccountInstrument(paymentInstrumentId, accountNumber, gpaMode, additionalHeaders = {}) {
        let promise = null;
        if (gpaMode) {
            promise = JsonRPCService.send(getProxiedServiceUrl('gatewayBilling'), 'removeBankAccount', [paymentInstrumentId, accountNumber], additionalHeaders);
        } else {
            promise = JsonRPCService.send(getProxiedServiceUrl('billingData'), 'removeBankAccount', [paymentInstrumentId], additionalHeaders);
        }
        return promise;
    },
    deleteBankAccountInstrumentWithSession(sessionToken, quoteID, paymentInstrumentID, additionalHeaders = {}) {
        const bankAccountRequestDTOML = {
            sessionUUID: sessionToken,
            quoteID: quoteID,
            paymentInstrumentID: paymentInstrumentID
        };
        return JsonRPCService.send(getProxiedServiceUrl('policyCommonPayment'), 'deleteBankAccountPaymentInstrument', [bankAccountRequestDTOML], additionalHeaders);
    },
    createOneTimeBankAccountInstrument(paymentDetailsDTO, gpaMode, additionalHeaders = {}) {
        let promise = null;
        if (gpaMode) {
            promise = JsonRPCService.send(getProxiedServiceUrl('gatewayPayment'), 'createOneTimeBankAccountInstrument', [paymentDetailsDTO], additionalHeaders);
        } else {
            promise = JsonRPCService.send(getProxiedServiceUrl('policyCommonPayment'), 'createOneTimeBankAccountInstrument', [paymentDetailsDTO], additionalHeaders);
        }
        return promise;
    },
    makeBankAccountDownPayment: (paymentRequestDTO, gpaMode, additionalHeaders = {}) => {
        let promise = null;
        if (gpaMode) {
            promise = JsonRPCService.send(getProxiedServiceUrl('gatewayBilling'), 'makeBankAccountDownPayment', [paymentRequestDTO], additionalHeaders);
        } else {
            promise = JsonRPCService.send(getProxiedServiceUrl('billingData'), 'makeBankAccountDownPayment', [paymentRequestDTO], additionalHeaders);
        }
        return promise;
    },
    makeAgencySweepDownPayment: (paymentRequestDTO, additionalHeaders = {}) => {
        return JsonRPCService.send(getProxiedServiceUrl('gatewayBilling'), 'makeAgencySweepDownPayment', [paymentRequestDTO], additionalHeaders);
    },
    getCCPermission: () => {
        return JsonRPCService.send(getProxiedServiceUrl('gatewayPayment'), 'getCCPermission', []);
    },
    getPolicyPaymentInstrumentsForAccount(accountNumber, gpaMode = false, additionalHeaders = {}) {
        if (gpaMode) {
            return JsonRPCService.send(getProxiedServiceUrl('gatewayBilling'), 'getPolicyPaymentInstrumentsForAccount', [accountNumber], additionalHeaders);
        }
        return JsonRPCService.send(getProxiedServiceUrl('billingData'), 'getPolicyPaymentInstrumentsForAccount', [], additionalHeaders);
    },
    isSuspensePaymentRequired: (paymentInfo) => {
        const isPayOnlineOrByMail = paymentInfo.ratingPaymentMethod_ML === MLRatingPaymentMethods.PAY_ONLINE_OR_BY_MAIL;
        const isMortgageeSecondYear = paymentInfo.ratingPaymentMethod_ML === MLRatingPaymentMethods.MORTGAGEE && !paymentInfo.firstYear_ML.value;
        const isPaidByBankAccount = paymentInfo.ratingPaymentMethod_ML === MLRatingPaymentMethods.BANK_ACCOUNT;
        const isDownpaymentPaidByBankAccount = paymentInfo.downPaymentMethod_ML === MLAccountPaymentMethods.BANK_ACCOUNT;
        const isDownpaymentMade = paymentInfo.confirmationNumber_ML !== undefined;

        // suspense payments must be created for Bank Account payments as there are no PC-BC integrations to do it from PC
        return !paymentInfo.downPaymentOverride_ML && !isDownpaymentMade
            && (isPaidByBankAccount
                || (isDownpaymentPaidByBankAccount && (isPayOnlineOrByMail || isMortgageeSecondYear))
            );
    },
    getCustomerBankNameByRoutingNumber: (routingNumber, additionalHeaders = {}) => {
        const serviceEndPoint = getProxiedServiceUrl('gatewayBilling');
        return JsonRPCService.send(serviceEndPoint, 'getCustomerBankNameViaRoutingNumber', [routingNumber], additionalHeaders);
    },

    getBoAPaymentInstruments(sessionID, quoteID, accountNumber, gpaMode, additionalHeaders = {}) {
        if (gpaMode) {
            return JsonRPCService.send(getProxiedServiceUrl('gatewayPayment'),
                'getBoAPaymentInstruments', [accountNumber], additionalHeaders);
        }

        const paymentInstrumentRequestDTOML = {
            sessionUUID: sessionID,
            quoteID
        };
        return JsonRPCService.send(getProxiedServiceUrl('policyCommonPayment'),
            'getBoAPaymentInstruments', [paymentInstrumentRequestDTOML], additionalHeaders);
    },

    getCreditCardPaymentInstruments(sessionID, quoteID, accountNumber, gpaMode, additionalHeaders = {}) {
        if (gpaMode) {
            return JsonRPCService.send(getProxiedServiceUrl('gatewayPayment'),
                'getCreditCardPaymentInstruments', [accountNumber], additionalHeaders);
        }

        const paymentInstrumentRequestDTOML = {
            sessionUUID: sessionID,
            quoteID
        };
        return JsonRPCService.send(getProxiedServiceUrl('policyCommonPayment'),
            'getCreditCardPaymentInstruments', [paymentInstrumentRequestDTOML], additionalHeaders);
    },

    usePaymentusACH(gpaMode, additionalHeaders = {}) {
        if (gpaMode) {
            return JsonRPCService.send(getProxiedServiceUrl('gatewayPayment'),
                'usePaymentusACH', [], additionalHeaders);
        }
        return JsonRPCService.send(getProxiedServiceUrl('policyCommonPayment'),
            'usePaymentusACH', [], additionalHeaders);
    }
};
